<template>
  <div class="UserAccounts">
    <div v-if="loading">
      <b-spinner class="align-middle" label="Loading..."></b-spinner>
    </div>
    <div v-if="!show_details">
      <b-list-group class="px-2" v-if="!loading">
        <b-list-group-item
          v-if="mainAccount"
          @click="show_account_details(mainAccount)"
          class="flex-column align-items-start my-2"
          style="border-radius: 15px; border-color: blue; cursor: pointer"
        >
          <b-row align-v="center" align-h="start">
            <b-col md="6 ">
              <h5 class="mb-1 text-font-black">
                {{ mainAccount.name }}
              </h5>
            </b-col>
            <b-col md="6">
              <h5 class="mb-1 text-font-black">Balance</h5>
              <p class="mb-1 text-light-black">
                <strong>${{ mainAccount.overview.balance }}</strong>
              </p>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
      <b-button @click="modalShowAccount=true">Agregar nueva cuenta</b-button>

<b-modal id="modal-1" v-model="modalShowAccount" title="Nueva cuenta para el usuario" hide-footer>
  
  <b-form @submit.prevent="addAccount">
      <b-form-group
        id="input-group-name"
        label="Nombre"
        label-for="input-name"

      >
        <b-form-input
          id="input-name"
          v-model="user_account_save.name"
          placeholder="Ingrese nombre de la cuenta"
        ></b-form-input>
      </b-form-group>
      
      <b-button type="submit" variant="secondary">Crear cuenta</b-button>
    </b-form>

</b-modal>
      <b-list-group
        class="px-2"
        v-if="!loading && secondaryAccounts.length > 0"
      >
        <b-list-group-item
          class="flex-column align-items-start my-2"
          style="
            border-radius: 15px;
            border-color: black !important;
            cursor: pointer;
            border-top-width: 1px;
          "
          v-for="account in secondaryAccounts"
          v-bind:key="account.id"
          @click="show_account_details(account)"
        >
          <b-row align-v="center" align-h="start">
            <b-col md="6">
              <h5 class="mb-1 text-font-black">
                {{ account.name }}
              </h5>
            </b-col>

            <b-col md="6">
              <h5 class="mb-1 text-font-black">Balance</h5>
              <p class="mb-1 text-light-black">
                <strong>${{ account.overview.balance }}</strong>
              </p>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
    </div>
    <div v-if="show_details">
      <div class="mx-auto my-3">
        <h1 class="text-center text-dark-black-title">{{ currentAccount }}</h1>
        <b-button
          pill
          class="btn-card-color text-font-white mr-auto"
          v-b-modal.modal-money
        >
          Administrar fondos</b-button
        >
      </div>
      <hr />
      <b-row align-v="center" align-h="start">
        <b-col md="3">
          <h5 class="mb-1 text-font-black">
            Ingresos: ${{ AccountBalance.incomes }}
          </h5>
          <h5 class="mb-1 text-font-black">
            Egresos: ${{ AccountBalance.outcomes }}
          </h5>
        </b-col>
        <b-col md="3">
          <h5 class="mb-1 text-font-black">Ingresos pendientes</h5>
          <h5 class="mb-1 text-font-black">
            ${{ AccountBalance.pending_incomes }}
          </h5>
        </b-col>
        <b-col md="3">
          <h5 class="mb-1 text-font-black">Egresos pendientes</h5>
          <p class="mb-1 text-light-black">
            <strong>${{ AccountBalance.pending_outcomes }}</strong>
          </p>
        </b-col>
        <b-col md="3">
          <h5 class="mb-1 text-font-black">Balance</h5>
          <p class="mb-1 text-light-black">
            <strong>${{ AccountBalance.balance }}</strong>
          </p>
        </b-col>
      </b-row>

      <b-row align-v="center" align-h="between" class="mb-3 p-4">
        <b-button
          pill
          class="btn-card-color text-font-white mr-auto"
          @click="backToAllAccounts()"
        >
          <v-icon name="arrow-left" scale="1"></v-icon> Volver a todas las
          cuentas</b-button
        >
        <b-col sm="5" md="7" cols="12" lg="5" class="ml-auto">
          <b-form-group
            label="Por página"
            label-cols-sm="6"
            label-cols-md="3"
            label-cols-lg="4"
            label-align-sm="right"
            label-size="sm"
            label-for="perPageSelect"
            class="mb-0"
          >
            <b-form-select
              v-model="perPage"
              id="perPageSelect"
              size="md"
              :options="pageOptions"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-table
        show-empty
        small
        stacked="md"
        class="text-left"
        style="font-family: Montserrat; font-weight: lighter; font-size: 14px"
        id="my-table"
        :items="AccountTransactionsTmp"
        :fields="AccountTransactionsFields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        :busy="isBusy"
      >
        <template v-slot:empty>
          <div class="mt-2 text-center">
            <h6>La cuenta no tiene transacciones</h6>
          </div>
        </template>

        <template v-slot:table-busy>
          <div class="text-center text-dark my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Cargando...</strong>
          </div>
        </template>

        <template v-slot:emptyfiltered>
          <div class="my-2 text-center">
            <h6>No se encontraron resultados</h6>
          </div>
        </template>
        <template v-slot:cell(status_payment_id)="row">
          <p v-if="row.value == 1">Pendiente</p>
          <p v-if="row.value == 2" style="color: green">
            Aprobado <v-icon name="check-circle"></v-icon>
          </p>
          <p v-if="row.value == 3" color="#CF173C">
            Rechazado <v-icon name="times-circle"></v-icon>
          </p>
          <!-- {{
            row.value == 1 ? "Pendiente" : row.value == 2 ? "Aprobada" : "Rechazada"
          }} -->
        </template>
        <template v-slot:cell(actions)="row">
          <b-button
            title="Aprobar"
            size="sm"
            variant="white"
            v-if="row.item.status_payment_id == 1"
            @click="changeStatus(row.item.id, 2, row.item.account.id)"
          >
            <v-icon name="check-circle" color="green"></v-icon>
          </b-button>
          <b-button
            title="Rechazar"
            size="sm"
            variant="white"
            v-if="row.item.status_payment_id == 1"
            @click="changeStatus(row.item.id, 3, row.item.account.id)"
          >
            <v-icon name="times-circle" color="#CF173C"></v-icon>
          </b-button>
          <b-button
            title="Eliminar"
            size="sm"
            class="mr-1"
            variant="white"
            v-if="row.item.type_transaction_id == 9 || row.item.type_transaction_id == 10"
            @click="deleteTransaction(row.item.id, row.item.account.id)"
          >
            <v-icon v-show="!hide" name="trash" color="#CF173C"></v-icon>
            <b-spinner
              v-show="hide"
              small
              variant="black"
              class="align-middle"
            ></b-spinner>
          </b-button>
        </template>
      </b-table>
      <b-col lg="5" class="mx-auto pt-2">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="md"
          class="my-0"
        ></b-pagination>
      </b-col>
    </div>
    
    <b-modal
      id="modal-money"
      ref="modal"
      title-class="text-font-black"
      title="Agregar o retirar fondos"
      hide-footer
      footer-class="text-font-black"
      @show="resetModal"
      @hidden="resetModal"
    >
      <b-container>
        <form ref="form" @submit.stop.prevent="ManageFounds">
          <b-row>
            <b-col lg="12">
              <p class="text-font-black" style="font-size: 13px">
                Aquí puedes agregar y retirar fondos, además de colocar las
                ganancias y pérdidas de las cuentas de inversión
              </p>
            </b-col>

            <b-col lg="12">
              <b-form-group
                label="Tipo de transacción"
                label-for="Tipo de transacción"
                label-class="text-light-black"
                invalid-feedback="Tipo de transacción"
              >
                <b-form-select
                  v-model="type_transaction"
                  id="type"
                  size="md"
                  :options="typeTmp"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col
              lg="6"
              v-if="type_transaction == 10 || type_transaction == 9"
            >
              <b-form-group
                label="Monto"
                type="number"
                min="0"
                label-class="text-light-black"
                label-for="amount_inout"
                invalid-feedback="Nombre requerido"
              >
                <b-form-input
                  id="amount_inout"
                  v-model="amount_inout"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="6" v-if="type_transaction == 3 || type_transaction == 4">
              <b-form-group
                label="Porcentaje"
                type="number"
                min="0"
                max="100"
                label-class="text-light-black"
                label-for="amount_inout"
              >
                <b-form-input
                  id="percent"
                  v-model="percent"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                label="Clave maestra"
                label-class="text-light-black"
                label-for="master_key"
                invalid-feedback="Clave requerida"
              >
                <b-form-input
                  id="master_key"
                  v-model="master_key"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col
              lg="12"
              class="mb-3"
              v-if="type_transaction == 3 || type_transaction == 4"
            >
              <b-form-group
                label="Descripción"
                label-class="text-light-black"
                label-for="Description"
              >
                <textarea
                  class="form-control"
                  rows="2"
                  label="Description"
                  v-model="description"
                ></textarea>
              </b-form-group>
            </b-col>
            <b-col lg="6" md="6" sm="6" v-show="!progress1"></b-col>

            <b-col lg="3" md="3" sm="3" cols="6" v-show="!progress1">
              <b-button
                style="border-radius: 12px; border: none"
                class="p-3"
                size="sm"
                @click="resetModal()"
              >
                <span class="text-font-white">Cancelar</span>
              </b-button>
            </b-col>
            <b-col lg="3" md="3" sm="3" cols="6" v-show="!progress1">
              <b-button
                style="border-radius: 12px; border: none"
                class="btn-card-color p-3"
                size="sm"
                @click="ManageFounds()"
              >
                <span class="text-font-white">Agregar</span>
              </b-button>
            </b-col>

            <b-col>
              <div v-show="progress1" class="text-center text-primary mt-3">
                <b-spinner small class="align-middle"></b-spinner>
                <strong class="ml-2">Cargando...</strong>
              </div>
            </b-col>
          </b-row>
        </form>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "UserAccount",
  data() {
    return {
      modalShow:false,
      selected: null,
      id_user: null,
      progress1: false,
      id_account: null,
      currentBalance: null,
      amount_inout: null,
      percent: null,
      description: null,
      master_key: null,
      type_transaction: "9",
      typeTmp: [
        { value: "9", text: "Ingreso" },
        { value: "10", text: "Egreso" },
        { value: "3", text: "Ganancia" },
        { value: "4", text: "Pérdidas" },
      ],
      hide: false,
      loading: true,
      mainAccount: {
        overview: {},
      },
      secondaryAccounts: [],
      currentAccount: "",
      accountId: "",
      show_details: false,
      AccountTransactionsTmp: [],
      AccountTransactions: [],
      AccountTransactionsFields: [
        {
          key: "type.name",
          label: "Tipo",
          sortable: true,
        },
        {
          key: "amount",
          label: "Monto",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "payment_method.name",
          label: "Forma de depósito",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "status_payment_id",
          label: "Estado",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "created_at",
          label: "Fecha",
          sortable: true,
          sortDirection: "desc",
        },
        { key: "actions", label: "Acciones" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 15, 20],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      isBusy: false,
      filterOn: [],
      AccountBalance: {},
      user_account_save:{
        user_id:0,
        name:'',
        type_user_account:0
      },
      user_account_update:{
        user_id:0,
        name:'',
        type_user_account:0
      },
      modalShowAccount:false
    };
  },
  computed: {
    ...mapState({
      me: (state) => state.me,
    }),
  },
  mounted() {
    this.getUserAccounts();
  },
  methods: {
    ...mapActions([
      "GetAccountsByUser",
      "GetAccountTransactions",
      "GetAccountBalance",
      "changePayStatus",
      "StoreAny",
      "StoreByPercent",
      "changeTransactionStatus",
      "StoreUserAccount"
    ]),
    OpenImg(data) {
      console.log(data);
      window.open(data, "_blank");
    },
    SelectReport(data) {
      console.log(data);
      this.selected = data;
      this.$nextTick(() => {
        this.$bvModal.show("modal-report2");
      });
    },
    resetModal() {
      this.$nextTick(() => {
        this.$bvModal.hide("modal-money");
      });
      this.amount_inout = "";
      this.master_key = "";
      this.type_transaction = "9";
      this.percent = "";
      this.description = "";
    },
    addAccount() {
      //Validacion de datos nulos
          Swal.fire({
          title: "¡Atención!",
          text: "¿Estás seguro de crear esta cuenta para el usuario?",
          icon: "question",
          reverseButtons: true,
          showCancelButton: true,         
          cancelButtonText: "Cancelar",
          confirmButtonText: "Si, crear",
        }).then((result) => {
          if (result.value) {
            this.deleting = true;
            let form = {
              url: "user_account/save",
              data: {
                user_id: this.$route.params.user_id,
                name: this.user_account_save.name,
                type_user_account_id: 2,  
              },
            };
            this.StoreUserAccount(form.data)
              .then((response) => {
                if (response.code === 200) {
                  this.deleting = false;
                  Swal.fire({
                    title: "Operación guardada correctamente",
                    icon: "success",
                    showConfirmButton: false,
                    showLoaderOnConfirm: true,
                    timer: 1000,
                  });

                  this.modalShowAccount = false;
                  this.getUserAccounts();
                }
                else if (response.code === 409) {
                  Swal.fire({
                    title: 'Vehículo repetido',
                    text: 'El vehículo se encuentra repetido',
                    icon: 'warning',
                    customClass: {
                      confirmButton: "btn-info"
                    },
                    confirmButtonText: 'Aceptar',
                  })
                  this.getUserAccounts();
                }
              })
              .catch((error) => {
                console.log(error);
                this.deleting = false;
                alert("Ocurrió un error, intente más tarde");
                this.AllElements();
              });
          }
        });
      
    },
    ManageFounds() {
      if (this.type_transaction == "3" || this.type_transaction == "4") {
        if (this.currentAccount == "Cuenta de liquidez") {
        Swal.fire({
          title: "Atención",
          text: "Las ganancias y pérdidas solo puedes agregarse en cuentas de inversión",
          icon: "error",
        });
      } else if (this.percent < 0 || this.percent > 100) {
        Swal.fire({
          title: "Atención",
          text: "Debes un porcentaje entre 0 y 100 %",
          icon: "warning",
        });
      } else if (this.master_key == null || this.master_key == "") {
        Swal.fire({
          title: "Atención",
          text: "Debes colocar la clave maestra para continuar",
          icon: "warning",
        });
      } else {
        Swal.fire({
          title: "Atención",
          text:
            "¿Está seguro que desea agregar una operación de " +
            this.percent +
            "% ?",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#121419",
          reverseButtons: true,
          confirmButtonText: "Sí, seguro",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.isConfirmed) {
            this.progress1 = true;

            let form = {
              user_id: this.id_user,
              type_user_account: this.currentAccount,
              type_transaction_id: this.type_transaction,
              percentage: this.percent,
              description: this.description,
              master_key: this.master_key,
            };
            this.StoreByPercent(form)
              .then((response) => {
                if (response.code == 200) {
                  Swal.fire({
                    title: "Listo",
                    text: "Se ha realizado la operación",
                    icon: "success",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  this.progress1 = false;
                  this.$nextTick(() => {
                    this.$bvModal.hide("modal-money");
                  });
                  this.show_details = false;
                  this.getUserAccounts();
                } else if (response.code == 400) {
                  Swal.fire({
                    title: "Error",
                    text: "La clave es incorrecta, intente nuevamente",
                    icon: "error",
                  });
                  this.progress1 = false;
                } else {
                  this.progress1 = false;

                  Swal.fire({
                    title: "Error",
                    text: "",
                    icon: "warning",
                  });
                }
              })
              .catch((error) => {
                this.progress1 = false;
                console.log(error);
                Swal.fire({
                  title: "Error",
                  text: "Intente más tarde",
                  icon: "warning",
                });
              });
          }
        });
      }
      } else if (
        this.type_transaction == "9" ||
        this.type_transaction == "10"
      ) {
        if (this.amount_inout <= 0) {
          Swal.fire({
            title: "Atención",
            text: "Debes colocar un monto mayor a 0",
            icon: "warning",
          });
        } else if (this.master_key == null || this.master_key == "") {
          Swal.fire({
            title: "Atención",
            text: "Debes colocar la clave maestra para continuar",
            icon: "warning",
          });
        } else {
          this.progress1 = true;

          let form = {
            user_account_id: String(this.id_account),
            type_transaction_id: this.type_transaction,
            amount: this.amount_inout,
            master_key: this.master_key,
          };
          this.StoreAny(form)
            .then((response) => {
              if (response.code == 200) {
                Swal.fire({
                  title: "Listo",
                  text: "Se ha realizado la operación",
                  icon: "success",
                  showConfirmButton: false,
                  showLoaderOnConfirm: true,
                  timer: 1500,
                });
                this.progress1 = false;
                this.$nextTick(() => {
                  this.$bvModal.hide("modal-money");
                });
                this.show_details = false;
                this.getUserAccounts();
              } else if (response.code == 400) {
                Swal.fire({
                  title: "Error",
                  text: "La clave es incorrecta, intente nuevamente",
                  icon: "error",
                });
                this.progress1 = false;
              } else {
                this.progress1 = false;

                Swal.fire({
                  title: "Error",
                  text: "Intente más tarde",
                  icon: "warning",
                });
              }
            })
            .catch((error) => {
              this.progress1 = false;
              console.log(error);
              Swal.fire({
                title: "Error",
                text: "Intente más tarde",
                icon: "warning",
              });
            });
        }
      }
    },
    changeStatus(id, status, accountId) {
      let stat = status === 2 ? "aprobar" : "rechazar";
      Swal.fire({
        title: "Atención",
        text: "¿Estás seguro que deseas " + stat + " esta inversión?",
        icon: "question",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: "#121419",
        confirmButtonText: "Sí, seguro",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          let form = {
            id: id,
            status: status,
          };
          Swal.showLoading();
          this.changePayStatus(form)
            .then((response) => {
              if (response.code === 200) {
                Swal.fire({
                  title:
                    status === 2
                      ? "Se ha verificado la transacción"
                      : "Se ha rechazado la transacción",
                  icon: "success",
                  showConfirmButton: false,
                  showLoaderOnConfirm: true,
                  timer: 1000,
                });
                this.queryAccountDetails(accountId);
              } else if (response.code == 403) {
                Swal.fire({
                  title: "Atención",
                  text: "No puede verificar o rechazar un depósito mientras haya otro depósito más antiguo sin verificar",
                  icon: "error",
                });
              }
            })
            .catch((error) => {
              console.log(error);
              alert("Ocurrió un error, intente más tarde");
              this.queryAccountDetails(accountId);
            });
          console.log(form);
        }
      });
    },
    deleteTransaction(id, accountId) {
      console.log(id)
      Swal.fire({
        title: "Atención",
        text: "¿Estás seguro que deseas eliminar esta transacción?",
        icon: "question",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: "#121419",
        confirmButtonText: "Sí, seguro",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          let form = {
            id: id,
            status: '2',
          };
          Swal.showLoading();
          this.changeTransactionStatus(form)
            .then((response) => {
              if (response.code === 200) {
                Swal.fire({
                  title: 'Listo',
                  text: 'Se ha eliminado la transacción con éxito',
                  icon: "success",
                  showConfirmButton: false,
                  showLoaderOnConfirm: true,
                  timer: 1000,
                });
                this.queryAccountDetails(accountId);
              } /* else if (response.code == 403) {
                Swal.fire({
                  title: "Atención",
                  text: "No puede verificar o rechazar un depósito mientras haya otro depósito más antiguo sin verificar",
                  icon: "error",
                });
              } */
            })
            .catch((error) => {
              console.log(error);
              alert("Ocurrió un error, intente más tarde");
              this.queryAccountDetails(accountId);
            });
          console.log(form);
        }
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    backToAllAccounts() {
      this.getUserAccounts()
      this.show_details = false;

    },
    getUserAccounts() {
      this.loading = true;
      let form = {
        id: this.$route.params.user_id,
      };
      this.GetAccountsByUser(form)
        .then((response) => {
          if (response.code == 200) {
            let main_account = response.data.find(
              (x) => x.type_user_account_id === 1
            );
            this.mainAccount = main_account;
            let secondary_accounts = response.data.filter(
              (x) => x.type_user_account_id !== 1
            );
            this.secondaryAccounts = secondary_accounts;
            this.loading = false;
          }
        })
        .catch((error) => {
          console.log(error);
          alert("Ocurrió un error, intente más tarde");
        });
    },
    getAccountBalance(id) {
      this.GetAccountBalance({ id })
        .then((response) => {
          if (response.code == 200) {
            this.AccountBalance = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
          alert("Ocurrió un error, intente más tarde");
        });
    },
    show_account_details(data) {
      this.currentAccount = data.name;
      this.currentBalance = data.overview.balance;
      this.id_account = data.id;
      this.id_user = data.user_id
      this.loading = true;
      this.queryAccountDetails(data.id);
    },
    queryAccountDetails(id) {
      this.getAccountBalance(id);
      this.GetAccountTransactions({ id }).then((response) => {
        if (response.code == 200) {
          this.AccountTransactionsTmp = response.data;
          this.totalRows = response.data.length;
          this.loading = false;
          this.show_details = true;
        }
      });
    },
  },
};
</script>
<style scoped></style>
